// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  text-align: center;
}

ion-row {
  align-items: center;
}

button {
  height: 2.3rem;
  width: 2.3rem;
  border-radius: 100%;
  margin-right: 0.5rem;
}

ion-fab-list {
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  width: 100vh;
  margin-left: 3.3rem;
}

ion-fab-button {
  margin-right: 1rem;
}

.edit {
  background-color: #ffbd03;
}

.delete {
  background-color: #dd7973;
}

ion-icon {
  font-size: 1.3rem;
}

h2 {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/components/admin/coach/list-coach/list-coach.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,kCAAA;UAAA,0BAAA;EACA,YAAA;EACA,mBAAA;AACJ;;AAEA;EACA,kBAAA;AACA;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":["ion-title{\r\n    text-align: center;\r\n}\r\n\r\nion-row{\r\n    align-items: center;\r\n}\r\n\r\nbutton{\r\n    height: 2.3rem;\r\n    width: 2.3rem;\r\n    border-radius: 100%; \r\n    margin-right: 0.5rem;\r\n}\r\n\r\nion-fab-list{\r\n    backdrop-filter: blur(5px);\r\n    width: 100vh;\r\n    margin-left: 3.3rem;\r\n}\r\n\r\nion-fab-button{\r\nmargin-right: 1rem;\r\n}\r\n\r\n.edit{\r\n    background-color: #ffbd03;\r\n}\r\n\r\n.delete{\r\n    background-color: #dd7973;\r\n}\r\n\r\nion-icon{\r\n    font-size: 1.3rem;\r\n}\r\n\r\nh2{\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
